<template>
  <product-box-list
    :products="products"
    tracking-list="containedInSet"
    :hide-cart-button="false"
  />
</template>

<script lang="ts">
  import {Options, Prop} from 'vue-property-decorator';
  import ProductBoxData from '../../types/ProductBoxData';
  import productStore from '../../stores/product/ProductStore';
  import ProductBoxList from '../productBoxList/productBoxList.vue';
  import {ProductDetailsSectionMixin, ProductDetailsSectionClass} from '../../utilities/vueMixins/productDetailsSectionMixin/productDetailsSectionMixin';

  @Options({
    name: 'product-contained-in-set',
    components: {ProductBoxList},
    mixins: [ProductDetailsSectionMixin]
  })
  export default class ProductContainedInSet extends ProductDetailsSectionClass {
    @Prop({default: false})
    hideCartButton: boolean;

    productStore = productStore;

    get products(): ProductBoxData[] {
      this.hideContainer(productStore.containedInSet.length === 0);
      return productStore.containedInSet;
    }
  }
</script>
